import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-link-sharing',
  templateUrl: './link-sharing.component.html',
  styleUrls: ['./link-sharing.component.scss']
})
export class LinkSharingComponent {

  @Input()
  url?: string = window.location.href;

  constructor() { }

  copyText() {
    const textField = document.getElementById("challenge-id") as HTMLInputElement;
    textField.select();
    textField.setSelectionRange(0, 99999); // for mobile devices

    // Copy the text inside the text field
    document.execCommand("copy");
  }

}